import { render } from "./Lavados.vue?vue&type=template&id=728c40ba"
import script from "./Lavados.vue?vue&type=script&lang=js"
export * from "./Lavados.vue?vue&type=script&lang=js"

import "./Lavados.vue?vue&type=style&index=0&id=728c40ba&lang=css"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__